var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#70b6fe",
    d: "m14.406 5.503 1.56 1.56c2.485 2.486 2.502 6.47.037 8.935-2.464 2.465-6.449 2.448-8.934-.037l-1.56-1.56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c4def9",
    d: "m26.498 17.596-1.56-1.56c-2.485-2.486-6.47-2.502-8.935-.038-2.464 2.465-2.447 6.45.038 8.935l1.56 1.56"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0572e4",
    fillRule: "evenodd",
    d: "M-254.604 553.72a.5.5 0 0 0-.347.86l.351.352-6.943 6.943a.5.5 0 0 0 .707.707l6.943-6.943.502.502a6 6 0 0 1 .53.617l-6.19 6.187a.5.5 0 0 0 .71.707l6.03-6.033c.264.51.448 1.047.551 1.596l-4.084 4.086a.5.5 0 1 0 .705.707l3.47-3.469a5.74 5.74 0 0 1-1.685 3.83c-2.273 2.273-5.929 2.258-8.226-.039l-1.56-1.559a.5.5 0 1 0-.708.707l1.559 1.561a6.836 6.836 0 0 0 7.492 1.479 6.83 6.83 0 0 0 .535 6.304.5.5 0 0 0 .092.149c.246.366.53.714.854 1.039l1.56 1.56a.5.5 0 1 0 .707-.707l-.353-.353 6.933-6.934a.5.5 0 0 0-.363-.857.5.5 0 0 0-.342.15l-6.935 6.936-.5-.502a6.012 6.012 0 0 1-.53-.617l6.178-6.178a.5.5 0 0 0-.363-.86.5.5 0 0 0-.344.153l-6.021 6.021a5.82 5.82 0 0 1-.551-1.595l4.074-4.075a.5.5 0 0 0-.363-.86.5.5 0 0 0-.342.151l-3.46 3.457a5.741 5.741 0 0 1 1.685-3.826c2.273-2.273 5.931-2.26 8.228.037l1.559 1.563a.5.5 0 0 0 .707-.71l-1.559-1.558a6.853 6.853 0 0 0-4.828-2.017 6.749 6.749 0 0 0-2.662.535 6.84 6.84 0 0 0-1.483-7.49l-1.56-1.561a.5.5 0 0 0-.36-.152z",
    color: "#000",
    fontFamily: "sans-serif",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    fontWeight: 400,
    overflow: "visible",
    transform: "translate(269.004 -548.723)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.1b3bf268dc8fdec14cf7956b2a7509be.svg";
export { ForwardRef as ReactComponent };